import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';
import { set } from "lodash";
import { useNavigate } from 'react-router-dom';

export default function Bulkprocessing() {
  const navigate = useNavigate()
  const [products, setProducts] = useState([])
  const [credentials,setCredentials] = useState(null)
  const [isAuth, setIsauth] = useState(false)
  const [agent, setAgent] = useState('')
  const [agentCode, setAgentcode] = useState('')
  const [productCode, setProductcode] = useState('')
  const [coverOptions, setCoveroptions] = useState([])
  const [coverOptioncode, setCoveroptioncode] = useState('');
  const [insuredItems, setInsureditems] = useState([])
  const [selectedItem, setSelecteditem] = useState('')
  const [coverOption, setCoveroption] = useState(null);
  const [coverPeriod, setCoverperiod] = useState('')
  const [selectedFile, setSelectedFile] = useState(null)
  const [uploading, setUploading] = useState(false)
  const [uploadedData, setUploadedData] = useState([])
  const [approved, setApproved] = useState(0)
  const [makePaymenttext, setMakepaymenttext] = useState('MAKE PAYMENT')
  const [Dealercode, setDealercode] = useState('')
  const [parentIntermediary, setParentintermediary] = useState(null)  
    const [coverOptionname, setCoveroptionname] = useState('');

    const [capacity, setCapacity] = useState(0)
    const [sumInsured, setSuminsured] = useState(0)

    const [quoteText, setQuotetext] = useState('GET QUOTATION')
    const [step, setStep] = useState(1)
    const [premium, setPremium] = useState(null)
    const [stampduty, setStampduty] = useState(40);
    const [PHCF, setPHCF] = useState(null)
    const [trainingLevy, setTraininglevy] = useState(null)
    const [basicPremium, setBasicpremium] = useState(0)
    const [modal, setModal] = useState(false)
    const [modal2, setModal2] = useState(false)
    const [modal6, setModal6] = useState(false)
    const [reg,setReg] = useState('');
    const [makes, setMakes] = useState([]);
    const [makeCode, setMakecode] = useState('')
    const [makeName, setMakename] = useState('')
    const [modelCode, setModelcode] = useState('');
    const [modelName, setModelname] = useState('')
    const [models, setModels] = useState([]);
    const [chassis, setChassis] = useState('');
    const [engineNumber, setEnginenumber] = useState('');
    const [cc, setCC] = useState('');
    const [color, setColor] = useState('');
    const [tonnage, setTonnage] = useState(0);
    const [yom, setYom] = useState('')

    const [firstName, setFirstname] = useState("")
    const [lastName, setLastname] = useState("");
    const [otherNames, setOthernames] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [idNumber, setIDNumber] = useState("");
    const [pin, setPin] = useState("");
    const [submitText, setSubmittext] = useState('SUBMIT')
    const [commencement, setCommencement] = useState('');
    const [commencementDate, setCommencementDate] = useState('')
    const [commencementUnix, setCommencementunix] = useState(null)
    const [expiryUnix, setExpiryunix] = useState(null)
    const [expiry, setExpiry] = useState('');
    const [expiryDate, setExpirydate] = useState('')
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [searchTerm2, setSearchTerm2] = useState('');
    const [suggestions2, setSuggestions2] = useState([]);
    const [searchTerm3, setSearchTerm3] = useState('');
    const [suggestions3, setSuggestions3] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [doubleInsurancestatusLoading, setDoubleinsuranceloading] = useState(false)
    const [doubleInsurancestatus, setDoubleinsurancestatus] = useState(null)
    const [doubleinsuranceMessage, setDoubleinsuracemessage] = useState('')
    const [checking, setChecking] = useState(1);
    const [selectedOption, setSelectedOption] = useState('GROSS');
    const [payAmount, setPayamount] = useState(0);
    const [mpesaPhone, setMpesaphone] = useState('');
    const [prdCode, setPrdcode] = useState('');
    const [productName, setProductname] = useState("")
    const [coverDays, setCoverdays] = useState('')
    const [commission, setCommission] = useState('')
    const [netCommission, setNetcommission] = useState('');
    const [netPremium, setNetprememium] = useState('')
    const [commissionRate, setCommissionrate] = useState('');
    const [today, setToday] = useState(null)
    const [payTest, setPaytext] = useState('SEND REQUEST')
    const [resendText, setResendtext] = useState('RESEND REQUEST')
    const [iraCode, setIracode] = useState('')
    const [bodyCode, setBodycode] = useState('');
    const [bodyType, setBodytype] = useState('')
    const [clientEmail,setClientemail] = useState('')
    const [clientName, setClientname] = useState('')
    const [clientPhone, setClientphone] = useState('')
    const [clientPin, setClientpin] = useState('')
    const [iraNumber, setIranumber] = useState('')
    const [coverType, setCovertype] = useState('')
    const [policyNumber, setPolicynumber] = useState('')
    const [isCert, setIscert] = useState(0)
    const [certURL, setCertURL] = useState('')
    const [eMessage, setEmessage] = useState('')
    const [paymentMode, setPaymentMode] = useState(0);
    const [utilize, setUtilize] = useState(0);
    const [walletBallance, setWalletbalance] = useState(0);
    const [walletNo, setWalletno] = useState('')
    const [numberOfDays, setNumberOfDays] = useState(0);
    const [riskClass, setRiskclass] = useState('')
    const [availableCommission, setAvailablecommission] = useState(0)
    const [errorCode, setErrorcode] = useState('')
    const [errorMessage, setErrormessage] = useState('')
    const [isMpesa, setIsmpesa] = useState(true)
    const [comm2, setComm2] = useState(0)
    const [nc2, setNc2] = useState(0)
    const [file, setFile] = useState(null)
    const [poid, setPoid] = useState("")
    const [ex, setEx] = useState('Expiry Date')
    const [cm, setCm] = useState('')
    const [agentName,setAgentname] = useState('')
    const [file1, setFile1] = useState(null)
    const [file2, setFile2] = useState(null)
    const [file3, setFile3] = useState(null)
    const [folderID, setfolderID] = useState('')
    const [modal3, setModal3] = useState(false)
    const [mpesaCode, setMpesacode] = useState('')
    const [checkMpesa, setCheckmpesa] = useState(false)
    const [verifyText, setVerifytext] = useState('VERIFY')
    const [promptID, setPromptid] = useState(0)
    const [proposalOID, setProposalOID] = useState('')
    const [insuredOID, setInsuredOID] = useState('')
    const [branch, setBranch] = useState(null)
    const [insuredSchedule, setInsureschedule] = useState('')
    const [bulkPolicies, setBulkpolicies] = useState([]) 
    const [bpNumber, setBpnumber] = useState(null)
      
        const [DSFApproved, setDSFapproved] = useState(0) 

    const [mpesaClicke, setMpesaclicked] = useState(false)
    const [retryText, setRetrytext] = useState('Retry')
    const [paymentInitiated, setPaymentInitiated] = useState(false)
  const company = 'Definite'

    // Total gross premium computed from uploadedData GrossPremium values
  const totalGross = React.useMemo(() => {
    if (!uploadedData || uploadedData.length === 0) return 0
    return uploadedData.reduce((acc, row) => {
      const v = row && row.GrossPremium !== undefined && row.GrossPremium !== null ? parseFloat(row.GrossPremium) : NaN
      return acc + (isNaN(v) ? 0 : v)
    }, 0)
  }, [uploadedData])
  // Whether rows have been processed (have GrossPremium values)
  const processed = React.useMemo(() => {
    if (!uploadedData || uploadedData.length === 0) return false
    return uploadedData.some(r => r && r.GrossPremium !== undefined && r.GrossPremium !== null && String(r.GrossPremium).trim() !== '')
  }, [uploadedData])


        useEffect(()=>{
          
  
          const getAgentcode =async()=>{
              const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                   method:"GET",
                  headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                  }
              });
              const data = await res.json();
           
            setAgentcode(data.OID)
            setAgentname(data.Dealer_name)
            setBranch(data.Companyy)
            setDealercode(data.Dealer_type)
            setDSFapproved(data.DSFAllowed)
            setParentintermediary(data.ParentIntermediary)
            if(data.Approved){
                setApproved(1)
            }
            else{
                setApproved(0)
            }
              
          }
  

  
  
          if(agent && isAuth){
              getAgentcode()
              
          }
  
        },[agent,isAuth])

           useEffect(()=>{
            const getInsureditems =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getInsureditems?coverOption=${coverOptioncode}`,{
                     method:"GET",
                        headers:{
                          'Authorization': `Basic ${credentials}`,
                          'Content-Type': "application/json"
                        }
                });
                const data = await res.json();
                setInsureditems(data)
                if(data.length == 1){
                      setSelecteditem(data[0].OID)
                }
              
        
            }
        
            const getCoveroptiondetails =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCoveroptiondetails?cover=${coverOptioncode}`,{
                     method:"GET",
                        headers:{
                          'Authorization': `Basic ${credentials}`,
                          'Content-Type': "application/json"
                        }
                });
                const data = await res.json();
                setCoveroption(data.CoverOption)
            }
            if(coverOptioncode && isAuth){
                getInsureditems();
                getCoveroptiondetails();
            }
        
           },[coverOptioncode,isAuth])

     const getQuote =async()=>{
      if(Dealercode !== 185 && Dealercode !== 187){
          toast.error('You need an agent account to proceed')
      }
      else{
  
      if(approved == 1){
  
        
      if(productCode && coverOptioncode){
          if(coverOption == 1 || coverOption == 58){
              if(productCode != 4652 && productCode != 4653 && productCode != 4655 && productCode != 3604){
                  if(sumInsured >= 500000 ){
                  setQuotetext('CALCULATING...')
                  const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculatePremium?insuredItem=${selectedItem}&coverOption=${coverOptioncode}&sumInsured=${sumInsured}&capaciy=${capacity}&coverPeriod=${coverPeriod}&product=${productCode}&capacity=${capacity}`,{
                       method:"GET",
                          headers:{
                          'Authorization': `Basic ${credentials}`,
                          'Content-Type': "application/json"
                          }
                  })
                  const data = await res.json()
                  const {premium} = data;
                  if(premium){
                      setQuotetext('GET QUOTATION')
                      setPremium(premium)
                      setTraininglevy(0.002*premium)
                      const tl = Math.round(0.002*premium);
                      setPHCF(Math.round(0.0025*premium))
                      const ph = Math.round(0.0025*premium)
                      setBasicpremium(premium+tl+ph+stampduty)
                      setPayamount(premium+tl+ph+stampduty)
                      const com = Math.round(0.1*premium)
                      setCommission(com )
                      const netCom = Math.round(0.1*com)
                      const nc = com - netCom;
                      setNetcommission(nc)
                      setNetprememium((premium+tl+ph+stampduty)-nc)
                      setComm2(com)
                      setNc2(nc)
                      const activity = `Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                      insertLog(agentCode,activity)
                      setModal6(false)
                      setStep(2)
                  }
                  else{
                      setQuotetext('GET QUOTATION')
                       const activity = `Premium for product ${productName} not found`
                      insertLog(agentCode,activity)
                      toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                  }
              }
              else{
                  toast.error('Sum Insured cannot be below Kes. 500,000')
              }
  
              }
              else{
                  if(sumInsured >= 100000 ){
                  setQuotetext('CALCULATING...')
                  const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculatePremium?insuredItem=${selectedItem}&coverOption=${coverOptioncode}&sumInsured=${sumInsured}&capaciy=${capacity}&coverPeriod=${coverPeriod}&product=${productCode}&capacity=${capacity}`,{
                       method:"GET",
                          headers:{
                          'Authorization': `Basic ${credentials}`,
                          'Content-Type': "application/json"
                          }
                  })
                  const data = await res.json()
                  const {premium} = data;
                  if(premium){
                      setQuotetext('GET QUOTATION')
                      setPremium(premium)
                      setTraininglevy(0.002*premium)
                      const tl = Math.round(0.002*premium);
                      setPHCF(Math.round(0.0025*premium))
                      const ph = Math.round(0.0025*premium)
                      setBasicpremium(premium+tl+ph+stampduty)
                      setPayamount(premium+tl+ph+stampduty)
                      const com = Math.round(0.1*premium)
                      setCommission(com )
                      const netCom = Math.round(0.1*com)
                      const nc = com - netCom;
                      setNetcommission(nc)
                      setNetprememium((premium+tl+ph+stampduty)-nc)
                      setComm2(com)
                      setNc2(nc)
                      const activity = `Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                      insertLog(agentCode,activity)
                      setModal6(false)
                      setStep(2)
                  }
                  else{
                      setQuotetext('GET QUOTATION')
                       const activity = `Premium for product ${productName} not found`
                      insertLog(agentCode,activity)
                      toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                  }
              }
              else{
                  toast.error('Sum Insured cannot be below Kes. 100,000')
              }
              }
  
  
          }
          else if(coverOption == 2){
              if(capacity){
  
                  if(productCode == 4695 && tonnage > 3){
                      toast.error('Tonnage should be below 3 Tons')
                  }
                  else{
                                     
                  setQuotetext('CALCULATING...')
                  const res = await fetch(`https://digitalapi.definiteassurance.com/api/calculatePremium?insuredItem=${selectedItem}&coverOption=${coverOptioncode}&tonnage=${tonnage}&sumInsured=${sumInsured}&capacity=${capacity}&coverPeriod=${coverPeriod}&product=${productCode}`,{
                       method:"GET",
                  headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                  }
                  })
                  const data = await res.json()
                  const {premium,insuredItem} = data;
                  if(premium){
                      setSelecteditem(insuredItem)
                      setQuotetext('GET QUOTATION')
                      setPremium(premium)
                      setTraininglevy(0.002*premium)
                      const tl = Math.round(0.002*premium);
                      setPHCF(Math.round(0.0025*premium))
                      const ph = Math.round(0.0025*premium)
                      setBasicpremium(premium+tl+ph+stampduty)
                      setPayamount(premium+tl+ph+stampduty)
                      const com = Math.round(0.1*premium)
                      setCommission(com )
                      const netCom = Math.round(0.1*com)
                      const nc = com - netCom;
                      setNetcommission(nc)
                      setNetprememium((premium+tl+ph+stampduty)-nc)
                       const activity = `Premium calculated for product ${productName}.Amount:Kes ${premium+tl+ph+stampduty}`
                      insertLog(agentCode,activity)
                      setModal6(false)
                      setStep(2)
                  }
                  else{
                      setQuotetext('GET QUOTATION')
                      toast.error('NO PREMIUM SET! CONTACT SUPPORT')
                       const activity = `Premium calculation for product ${productName} not found`
                      insertLog(agentCode,activity)
                  } 
  
                  }
   
              }
              else{
                  toast.error('Specify capacity')
              }
          }
      }
      else{
          toast.error('Insufficient information')
      }
  
      }
      else{
  
           const activity = `Premium calculation failed! Account not approved`
          insertLog(agentCode,activity)
          toast.error('Your account is not approved. Kindly contact support!')
      }
  
      }
  
  
  
  
     
     }

     useEffect(() => {
        const getCoverdays=()=>{
          if(coverPeriod === 'Week'){
            setCoverdays(7)
          }
          else if(coverPeriod === 'Month' || coverPeriod === 'Monthly'){
            // Get the actual number of days in the current month (28/29/30/31)
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()
            // Get last day of current month by going to first day of next month and subtracting 1
            const daysInMonth = new Date(year, month + 1, 0).getDate()
            setCoverdays(daysInMonth)
          } 
          else if(coverPeriod === 'Annually'){
            setCoverdays(365)   
          }
          else if(coverPeriod === 'Fortnight'){
            setCoverdays(14)
          }
          else{
            // Default: get actual days in current month
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()
            const daysInMonth = new Date(year, month + 1, 0).getDate()
            setCoverdays(daysInMonth)
          }

        }

        if(coverPeriod){
          getCoverdays()
        } 


      }, [coverPeriod])
        useEffect(()=>{
          const now = new Date();
          
          // Format YYYY-MM-DD
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          
          // Format HH:mm:ss.SSS
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          const seconds = String(now.getSeconds()).padStart(2, '0');
          const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
          
          
  
          setToday(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`)
  
        },[])

  // Helper: download a small sample CSV for users to fill
  const downloadSampleCsv = () => {
    // The sample CSV is placed in the public folder at public/samplebullkprocessing.csv
    // It will be served at the app root at '/samplebullkprocessing.csv'
    const url = (process.env.PUBLIC_URL || '') + '/samplebullkprocessing.csv'
    const link = document.createElement('a')
    link.href = url
    // Use the download attribute to suggest a filename
    link.setAttribute('download', 'samplebullkprocessing.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file) return
    if (!file.name.toLowerCase().endsWith('.csv')) {
      toast.error('Please select a CSV file')
      e.target.value = null
      return
    }
    setSelectedFile(file)
  }

  // Read file content as text (returns a Promise)
  const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result)
      reader.onerror = (err) => reject(err)
      reader.readAsText(file)
    })
  }

  // Helpers to parse dd/MM/yyyy and format as 'YYYY-MM-DD HH:mm:ss.SSS'
  const parseDdMmYyyy = (str) => {
    if (!str) return null
    const s = String(str).trim()
    const parts = s.split(/[\/\-]/)
    if (parts.length < 3) return null
    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10) - 1
    const year = parseInt(parts[2], 10)
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null
    // set time to 12:22:00.000 as requested
    return new Date(year, month, day, 12, 22, 0, 0)
  }

  const formatDateTime = (date) => {
    if (!date) return ''
    const pad = (n, z = 2) => String(n).padStart(z, '0')
    const year = date.getFullYear()
    const month = pad(date.getMonth() + 1)
    const day = pad(date.getDate())
    const hours = pad(date.getHours())
    const minutes = pad(date.getMinutes())
    const seconds = pad(date.getSeconds())
    const ms = String(date.getMilliseconds()).padStart(3, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${ms}`
  }

  const addDays = (date, days) => {
    const d = new Date(date.getTime())
    d.setDate(d.getDate() + days)
    return d
  }

  const addMonths = (date, months) => {
    const d = new Date(date.getTime())
    const targetMonth = d.getMonth() + months
    d.setMonth(targetMonth)
    return d
  }

  const getLastDayOfMonth = (date) => {
    const d = new Date(date.getTime())
    // Get the last day of the month by going to the first of next month and subtracting 1 day
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0)
    // Set time to same as the commencement date
    lastDay.setHours(d.getHours())
    lastDay.setMinutes(d.getMinutes())
    lastDay.setSeconds(d.getSeconds())
    lastDay.setMilliseconds(d.getMilliseconds())
    return lastDay
  }

  // Parse CSV text into array of objects with expected columns
  const parseCsvText = (text) => {
    if (!text) return []
    // Remove \r and trim
    const clean = text.replace(/\r/g, '').trim()
    if (!clean) return []
    const lines = clean.split('\n').filter(l => l.trim() !== '')
    if (lines.length < 1) return []
    // Helper to split a CSV line respecting quoted fields
    const splitCsvLine = (line) => {
      const result = []
      let cur = ''
      let inQuotes = false
      for (let i = 0; i < line.length; i++) {
        const ch = line[i]
        if (ch === '"') {
          if (inQuotes && line[i + 1] === '"') {
            // escaped quote
            cur += '"'
            i++
          } else {
            inQuotes = !inQuotes
          }
        } else if (ch === ',' && !inQuotes) {
          result.push(cur)
          cur = ''
        } else {
          cur += ch
        }
      }
      result.push(cur)
      return result.map(s => s.trim().replace(/^"|"$/g, ''))
    }
    // Parse headers (remove BOM if present)
    let headers = splitCsvLine(lines[0]).map(h => h.replace(/^\uFEFF/, '').trim())

    const rows = lines.slice(1).map(line => {
      const cols = splitCsvLine(line)
      const obj = {}
      headers.forEach((h, i) => {
        obj[h] = cols[i] !== undefined ? cols[i] : ''
      })
      return obj
    })
    // Normalize to expected columns (case-insensitive match)
    const expected = ['CustomerFirstName','CustomerLastName','CustomerIDNumber','CustomerPhoneNumber','CustomerKRA','CommencementDate','Registration','SumInsured','Capacity','Make','Model','ChassisNumber','EngineNumber','YOM','CC','Color']
    const mapped = rows.map(r => {
      const out = {}
      expected.forEach(h => {
        const key = Object.keys(r).find(k => k.toLowerCase() === h.toLowerCase())
        out[h] = key ? r[key] : ''
      })
      return out
    })

    // Remove rows that are completely empty (all expected fields empty or whitespace)
    const isEmptyRow = (obj) => {
      return expected.every(h => {
        const v = obj[h]
        if (v === undefined || v === null) return true
        const s = String(v).replace(/\u00A0/g, '').trim()
        return s === ''
      })
    }

    const filtered = mapped.filter(r => !isEmptyRow(r))
    console.log(`Parsed CSV rows: total=${mapped.length}, kept=${filtered.length}`)
    console.log('Sample kept rows:', filtered.slice(0,5))
    return filtered
  }

  // Upload the selected CSV file to backend via FormData
  const uploadFile = async () => {
    if (!selectedFile) {
      toast.error('No file selected')
      return
    }
    setUploading(true)
    try {
      // Parse file client-side and display in the table before/after uploading
      try {
        const text = await readFileAsText(selectedFile)
        const parsed = parseCsvText(text)
        // compute commencementUnix and expiryUnix for each row based on CommencementDate and coverPeriod
        const computed = parsed.map(row => {
          // prefer row's CoverPeriod if present, otherwise global coverPeriod
          const rowCover = (row.CoverPeriod || row.coverPeriod || coverPeriod || '').toString()
          const commDateStr = row.CommencementDate || row.commencement || ''
          const parsedDate = parseDdMmYyyy(commDateStr)
          let CommencementUnix = ''
          let ExpiryUnix = ''
          if (parsedDate) {
            CommencementUnix = formatDateTime(parsedDate)

            // Calculate expiry based on coverPeriod
            let expiryDate = null
            const cp = rowCover
            if (cp === 'Week') {
              expiryDate = addDays(parsedDate, 7 - 1)
            } else if (cp === 'Fortnight') {
              expiryDate = addDays(parsedDate, 14 - 1)
            } else if (cp === 'Monthly') {
              // Last day of the current month minus 1 day
              const lastDay = getLastDayOfMonth(parsedDate)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === '3Installments' || cp === '3installments') {
              // Last day of the month that is 3 months ahead minus 1 day
              const threeMonthsAhead = addMonths(parsedDate, 3)
              const lastDay = getLastDayOfMonth(threeMonthsAhead)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === '6Installments' || cp === '6installments') {
              // Last day of the month that is 6 months ahead minus 1 day
              const sixMonthsAhead = addMonths(parsedDate, 6)
              const lastDay = getLastDayOfMonth(sixMonthsAhead)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === '10Installments' || cp === '10installments') {
              // Last day of the month that is 10 months ahead minus 1 day
              const tenMonthsAhead = addMonths(parsedDate, 10)
              const lastDay = getLastDayOfMonth(tenMonthsAhead)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === 'Annually' || cp === 'Annual') {
              expiryDate = addDays(parsedDate, 365 - 1)
            } else {
              // default: monthly style (last day of current month minus 1)
              const lastDay = getLastDayOfMonth(parsedDate)
              expiryDate = addDays(lastDay, -1)
            }

            if (expiryDate) ExpiryUnix = formatDateTime(expiryDate)
          }

          return { ...row, CommencementUnix, ExpiryUnix }
        })
        setUploadedData(computed)
      } catch (parseErr) {
        console.error('CSV parse error', parseErr)
        toast.error('Could not parse CSV for preview')
      }
      const formData = new FormData()
      formData.append('file', selectedFile)

      const res = await Axios.post('https://digitalapi.definiteassurance.com/api/uploadBulkCSV', formData, {
        headers:
         {
          'Content-Type': 'multipart/form-data',
          ...(credentials ? { Authorization: `Basic ${credentials}` } : {})
        }
      })
      toast.success(res.data?.message || 'File uploaded successfully')
      setSelectedFile(null)
    } catch (err) {
      // Improved error reporting for easier debugging
      console.error('Upload error', err)
      if (err.response) {
        // Server responded with a status code outside 2xx
        console.error('Upload response data:', err.response.data)
        const status = err.response.status
        const body = JSON.stringify(err.response.data)
        toast.error(`Upload failed: ${status} ${err.response.statusText} - ${body}`)
      } else if (err.request) {
        // Request was made but no response received (network / CORS)
        console.error('No response received for upload request', err.request)
        toast.error('Upload failed: no response from server (possible network or CORS issue)')
      } else {
        // Something else happened
        toast.error(`Upload failed: ${err.message}`)
      }
    } finally {
      setUploading(false)
    }
  }

  // Process each uploaded row by calling calculatePremium and store GrossPremium
  const processPolicies = async () => {


       if((Dealercode == 170 && DSFApproved !== "1")){
            toast.error('You need an agent account to proceed')
        }

        else{
          if(approved == 0){
              toast.error('Your account is not approved. Kindly contact support!')
              return
          }
          else{
            
    if (!uploadedData || uploadedData.length === 0) {
      toast.error('No uploaded rows to process')
      return
    }
    if (!productCode || !coverOptioncode) {
      toast.error('Select product and cover option before processing')
      return
    }
    setUploading(true)
    try {
      const credsHeader = credentials ? { Authorization: `Basic ${credentials}` } : {}
      const results = await Promise.all(uploadedData.map(async (row) => {
        // Try several field names for sumInsured and capacity
        const sumInsured = row['SumInsured'] || row['sumInsured'] || row['CC'] || row['cc'] || row['Capacity'] || row['capacity'] || ''
        const capaciy = row['Capacity'] || row['capacity'] || ''
        if (!sumInsured || !capaciy) {
          return { ...row, GrossPremium: 'Missing SumInsured/Capacity' }
        }

        // Compute commencementUnix and expiryUnix if not already present
        let CommencementUnix = row.CommencementUnix || row.commencementUnix || ''
        let ExpiryUnix = row.ExpiryUnix || row.expiryUnix || ''
        
        if (!CommencementUnix) {
          const rowCover = (row.CoverPeriod || row.coverPeriod || coverPeriod || '').toString()
          const commDateStr = row.CommencementDate || row.commencement || ''
          const parsedDate = parseDdMmYyyy(commDateStr)
          
          if (parsedDate) {
            CommencementUnix = formatDateTime(parsedDate)

            // Calculate expiry based on coverPeriod
            let expiryDate = null
            const cp = rowCover
            if (cp === 'Week') {
              expiryDate = addDays(parsedDate, 7 - 1)
            } else if (cp === 'Fortnight') {
              expiryDate = addDays(parsedDate, 14 - 1)
            } else if (cp === 'Monthly') {
              // Last day of the current month minus 1 day
              const lastDay = getLastDayOfMonth(parsedDate)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === '3Installments' || cp === '3installments') {
              // Last day of the month that is 3 months ahead minus 1 day
              const threeMonthsAhead = addMonths(parsedDate, 3)
              const lastDay = getLastDayOfMonth(threeMonthsAhead)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === '6Installments' || cp === '6installments') {
              // Last day of the month that is 6 months ahead minus 1 day
              const sixMonthsAhead = addMonths(parsedDate, 6)
              const lastDay = getLastDayOfMonth(sixMonthsAhead)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === '10Installments' || cp === '10installments') {
              // Last day of the month that is 10 months ahead minus 1 day
              const tenMonthsAhead = addMonths(parsedDate, 10)
              const lastDay = getLastDayOfMonth(tenMonthsAhead)
              expiryDate = addDays(lastDay, -1)
            } else if (cp === 'Annually' || cp === 'Annual') {
              expiryDate = addDays(parsedDate, 365 - 1)
            } else {
              // default: monthly style (last day of current month minus 1)
              const lastDay = getLastDayOfMonth(parsedDate)
              expiryDate = addDays(lastDay, -1)
            }

            if (expiryDate) ExpiryUnix = formatDateTime(expiryDate)
          }
        }

        // Fetch makeCode and modelCode from APIs
        let MakeCode = row.MakeCode || ''
        let ModelCode = row.ModelCode || ''
        
        const make = row.Make || row.make || ''
        const model = row.Model || row.model || ''

        try {
          // Fetch makeCode if make is provided
          if (make && !MakeCode) {
            const makeRes = await Axios.get(`https://digitalapi.definiteassurance.com/api/getMakecode?make=${encodeURIComponent(make)}`, {
              headers: {
                'Content-Type': 'application/json',
                ...credsHeader
              }
            })
            MakeCode = makeRes.data?.OID || ''
            if (MakeCode) setMakecode(MakeCode) // Set state for makeCode
          }

          // Fetch modelCode if model is provided
          if (model && !ModelCode) {
            const modelRes = await Axios.get(`https://digitalapi.definiteassurance.com/api/getModelcode?model=${encodeURIComponent(model)}`, {
              headers: {
                'Content-Type': 'application/json',
                ...credsHeader
              }
            })
            ModelCode = modelRes.data?.OID || ''
            if (ModelCode) setModelcode(ModelCode) // Set state for modelCode
          }
        } catch (err) {
          console.error('Error fetching make/model codes for row', row, err)
          // Continue processing even if make/model fetch fails
        }

        try {
          const params = {
            insuredItem: selectedItem || coverOptioncode,
            coverOption: coverOptioncode,
            sumInsured: sumInsured,
            capacity: capaciy,
            coverPeriod: coverPeriod || '',
            product: productCode
          }
          const res = await Axios.get('https://digitalapi.definiteassurance.com/api/calculatePremium', {
            params,
            headers: {
              'Content-Type': 'application/json',
              ...credsHeader
            }
          })
          const pre = res.data?.premium ?? res.data?.Premium ?? null
          setPremium(pre)
          setTraininglevy(0.002*pre)
          const tl = Math.round(0.002*pre);
          setPHCF(Math.round(0.0025*pre))
          const ph = Math.round(0.0025*pre)
          setBasicpremium(pre+tl+ph+stampduty)
          const gp = pre+tl+ph+stampduty
          setPayamount(pre+tl+ph+stampduty)
          const com = Math.round(0.1*pre)
          setCommission(com )
          const netCom = Math.round(0.1*com)
          const nc = com - netCom;
          setNetcommission(nc)
          setNetprememium((pre+tl+ph+stampduty)-nc)
          return { ...row, GrossPremium: gp !== null ? gp : 'No premium', CommencementUnix, ExpiryUnix, MakeCode, ModelCode }
        } catch (err) {
          console.error('Error calculating premium for row', row, err)
          return { ...row, GrossPremium: 'Error', CommencementUnix, ExpiryUnix, MakeCode, ModelCode }
        }
      }))

      setUploadedData(results)
      toast.success('Processed policies')
    } catch (err) {
      console.error('processPolicies error', err)
      toast.error('Processing failed')
    } finally {
      setUploading(false)
    }

          }
        }
        


  }
   function formatter(amount) {
    return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
    const close2 =()=>{
    setIscert(0)
    setPaytext('SEND REQUEST')
    setModal2(false);
    
  }

  // Clear uploaded data and reset related values
  const clearUploadedData = () => {
    setUploadedData([])
    setSelectedFile(null)
    // reset premium-related state that may have been set during processing
    setPremium(null)
    setBasicpremium(0)
    setPayamount(0)
    setTraininglevy(null)
    setPHCF(null)
    setPaymentInitiated(false) // Reset payment initiated flag
    toast.info('Uploaded data cleared')
  }

  // Create customers for each uploaded row via API
  const buyCover = async () => {
    if (!uploadedData || uploadedData.length === 0) {
      toast.error('No uploaded rows to create customers for')
      return
    }
    setUploading(true)
    const bp = await fetch('https://digitalapi.definiteassurance.com/api/getBulkpolicies')
    const bulkPolicies = await bp.json()
    setBpnumber(bulkPolicies.length + 1)  

    try {
      const credsHeader = credentials ? { Authorization: `Basic ${credentials}` } : {}
      const rows = [...uploadedData]
      const results = []
      let successfulBulkPolicies = 0

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]
        const payload = {
          firstName: row.CustomerFirstName || row.CustomerName || '',
          lastName: row.CustomerLastName || '',
          otherNames: row.CustomerOtherNames || row.OtherNames || '',
          phone: row.CustomerPhoneNumber || row.CustomerPhone || row.Phone || '',
          email: row.CustomerEmail || row.Email || '',
          idNumber: row.CustomerIDNumber || row.IDNumber || '',
          pin: row.CustomerKRA || row.KRA || row.Pin || '',
          agent: agentCode || agent
        }

        try {
          const res = await Axios.post('https://digitalapi.definiteassurance.com/api/createClient', payload, {
            headers: {
              'Content-Type': 'application/json',
              ...credsHeader
            }
          })

          const data = res.data || {}
          let clientOID = ''
          let clientStatus = ''
          
          if (data.success === true && data.exists === false && data.OID) {
            clientOID = data.OID
            clientStatus = 'created'
            setSelectedClient(data.OID) // Set selectedClient to the new client OID
          } else if (data.success === false && data.exists === true) {
            clientOID = data.OID || ''
            clientStatus = 'exists'
            if (data.OID) setSelectedClient(data.OID) // Set selectedClient to the existing client OID
          } else {
            clientOID = data.OID || ''
            clientStatus = 'error'
            if (data.OID) setSelectedClient(data.OID) // Set selectedClient even if error but OID exists
          }

          // After creating/finding client, create proposal if clientOID exists
          let proposalStatus = ''
          let policyNumber = ''
          let proposalOID = ''
          let insuredOID = ''
          let IOID = ''

          if (clientOID) {
            try {
              // Get today's date in the required format
              const todayDate = new Date()
              const todayFormatted = formatDateTime(todayDate)

              // Calculate row-specific premium components based on GrossPremium
              const grossPremium = parseFloat(row.GrossPremium) || 0
              const rowStampduty = 40
              // Reverse-engineer the base premium from GrossPremium
              // GrossPremium = premium + trainingLevy + PHCF + stampduty
              // where trainingLevy = 0.002 * premium, PHCF = 0.0025 * premium
              // So: GrossPremium = premium * (1 + 0.002 + 0.0025) + stampduty
              // => premium = (GrossPremium - stampduty) / 1.0045
              const rowPremium = grossPremium > rowStampduty ? (grossPremium - rowStampduty) / 1.0045 : 0
              const rowTrainingLevy = Math.round(0.002 * rowPremium)
              const rowPHCF = Math.round(0.0025 * rowPremium)
              const rowBasicPremium = Math.round(rowPremium + rowTrainingLevy + rowPHCF + rowStampduty)
              const rowCommission = Math.round(0.1 * rowPremium)
              const rowNetCommission = Math.round(0.1 * rowCommission)
              const rowNetCommissionAdjusted = rowCommission - rowNetCommission
              const rowNetPremium = rowBasicPremium - rowNetCommissionAdjusted

              // Calculate coverDays from commencementUnix and expiryUnix
              let rowCoverDays = 0
              const commUnix = row.CommencementUnix || row.commencementUnix || ''
              const expUnix = row.ExpiryUnix || row.expiryUnix || ''
              if (commUnix && expUnix) {
                try {
                  const commDate = new Date(commUnix)
                  const expDate = new Date(expUnix)
                  const diffTime = expDate.getTime() - commDate.getTime()
                  rowCoverDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1 // inclusive
                } catch (e) {
                  console.error('Error calculating coverDays', e)
                }
              }

              // Prepare proposal data from row and processed values
              const proposalPayload = {
                commissionRate: commissionRate || 0,
                agentCode: agentCode || agent,
                agentName: agentName || '',
                prdCode: prdCode || '',
                client: row.CustomerIDNumber || row.IDNumber || '',
                commencementUnix: commUnix,
                expiryUnix: expUnix,
                today: todayFormatted,
                coverDays: rowCoverDays,
                reg: row.Registration || row.reg || '',
                productCode: productCode || '',
                payAmount: grossPremium,
                premium: Math.round(rowPremium),
                basicPremium: rowBasicPremium,
                commission: rowCommission,
                stampduty: rowStampduty,
                PHCF: rowPHCF,
                trainingLevy: rowTrainingLevy,
                netCommission: rowNetCommissionAdjusted,
                netPremium: rowNetPremium,
                selectedClient: clientOID,
                makeCode: row.MakeCode || '',
                modelCode: row.ModelCode || '',
                capacity: row.Capacity || row.capacity || 0,
                color: row.Color || row.color || '',
                tonnage: row.Tonnage || row.tonnage || 0,
                yom: row.YOM || row.yom || '',
                coverOptioncode: coverOptioncode || '',
                sumInsured: row.SumInsured || row.sumInsured || 0,
                chassis: row.ChassisNumber || row.chassis || '',
                engineNumber: row.EngineNumber || row.engineNumber || '',
                cc: row.CC || row.cc || '',
                selectedItem: selectedItem || '',
                branch: branch || ''
              }

              const proposalRes = await fetch('https://digitalapi.definiteassurance.com/api/createProposal2', {
                method: "POST",
                headers: {
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                },
                body: JSON.stringify(proposalPayload),
                credentials: 'include'
              })

              const proposalData = await proposalRes.json()
              
              if (proposalData.success) {
                proposalStatus = 'created'
                policyNumber = proposalData.policyNumber || ''
                proposalOID = proposalData.proposalOID || ''
                insuredOID = proposalData.insuredOID || ''
                IOID = proposalData.IOID || ''

                // Set state with the proposal response values
                setProposalOID(proposalOID)
                setInsuredOID(insuredOID)
                setInsureschedule(IOID)

                // After successful proposal creation, insert bulk policy
                try {
                  const bulkPolicyPayload = {
                    proposalOID: proposalOID,
                    insuredOID: insuredOID,
                    IOID: IOID,
                    bpNumber: bulkPolicies.length + 1, // Incremental bulk policy number
                    agentCode: agentCode || agent,
                    today: todayFormatted
                  }

                  const bulkPolicyRes = await fetch('https://digitalapi.definiteassurance.com/api/insertBulkpolicy', {
                    method: "POST",
                    headers: {
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    },
                    body: JSON.stringify(bulkPolicyPayload),
                    credentials: 'include'
                  })

                  const bulkPolicyData = await bulkPolicyRes.json()
                  
                  if (bulkPolicyData.success) {
                    console.log('Bulk policy inserted successfully for row', row)
                    successfulBulkPolicies++
                  } else {
                    console.error('insertBulkpolicy failed for row', row, bulkPolicyData)
                  }
                } catch (bulkPolicyErr) {
                  console.error('insertBulkpolicy error for row', row, bulkPolicyErr)
                }
              } else {
                proposalStatus = 'error'
              }
            } catch (proposalErr) {
              console.error('createProposal2 error for row', row, proposalErr)
              proposalStatus = 'error'
            }
          }

          results.push({ 
            ...row, 
            clientStatus, 
            clientOID,
            proposalStatus,
            policyNumber,
            proposalOID,
            insuredOID,
            IOID
          })
        } catch (err) {
          console.error('createClient error for row', row, err)
          results.push({ ...row, clientStatus: 'error' })
        }

        // Update UI progressively: show processed rows and remaining rows
        setUploadedData([...results, ...rows.slice(i + 1)])
        // optional small delay to allow UI to breathe (uncomment if needed)
        // await new Promise(r => setTimeout(r, 50))
      }

      setUploadedData(results)
    
      // Calculate total payAmount from all GrossPremium values
      if (successfulBulkPolicies > 0) {
        const totalAmount = results.reduce((sum, row) => {
          const grossPremium = parseFloat(row.GrossPremium) || 0
          return sum + grossPremium
        }, 0)
        
        console.log('Setting payment amount:', totalAmount)
        console.log('Successful bulk policies:', successfulBulkPolicies)
        
        setPayamount(totalAmount)
        setPaymentInitiated(true) // Mark that payment has been initiated
        
        // Open payment modal after successful bulk policy insertions with a small delay
        setTimeout(() => {
          console.log('Opening modal2 for payment')
          setModal2(true)
         
        }, 300)
      } else {
        console.log('No successful bulk policies inserted')
        toast.warning('No bulk policies were successfully created')
      }
    } catch (err) {
      console.error('buyCover error', err)
      toast.error('Customer creation failed')
    } finally {
      setUploading(false)
    }
  }

    function generateUniqueId() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        result += chars[randomIndex];
    }
    return result;
}
function getFormattedDateTime() {
    const now = new Date();
    
    // Extract date parts (YYYY-MM-DD)
    const datePart = now.toISOString().split('T')[0];
    
    // Extract time parts (HH:MM:SS.mmm)
    const timePart = now.toISOString().split('T')[1].replace('Z', '');
    
    // Combine and return
    return `${datePart} ${timePart}`;
}

const insertCertificate=async(certLink,certNo,commencement,expiry,proposalOID,insuredOID)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificate',{
       method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID,insuredOID,expiryUnix:expiry,commencementUnix:commencement,certNo,certLink,today})
    })

    const data = await res.json()
}
const insertCertificateError=async(errorMes,proposalOID,insuredOID,expiryUnix,commencementUnix)=>{
    const res = await fetch('https://digitalapi.definiteassurance.com/api/insertCertificateerror',{
       method:"POST",
        headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
        },
        body:JSON.stringify({proposalOID,insuredOID,expiryUnix,commencementUnix,errorMes,today})
    })

    const data = await res.json()
}



  const initiatePayment =async()=>{
    setMpesaclicked(true)
        setPaytext('CHECKING PAYMENT...')
        // setModal2(false)
        toast.success('Prompt sent to phone!')
        const formattedNumber =clientPhone.slice(1);
        const formattedNumber2 ="254" + mpesaPhone.slice(1);
        const ref = generateUniqueId();
        const qref = `QP${ref}`
        const uuid = uuidv4();
        const dateDone = getFormattedDateTime();
        const accountNumber = `DA-BP00${bpNumber}`
        
        try {
          const res2 = await Axios.post('https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a',{formattedNumber2,payAmount,reg:accountNumber,qref,dateDone})
          
          const responseData = res2.data
          
          if (responseData.success === true) {
              const todayDate = new Date()
                  const todayFormatted = formatDateTime(todayDate)

            // Payment successful
            const transactionId = responseData.transactionId || 'N/A'
            toast.success(`Payment successful!`)
            setPaytext('APPROVAL PROCESS ONGOING...')
            console.log('Payment successful. Transaction ID:', transactionId)
                               const initiatePayload = {
                  
                    agentCode: agentCode || agent,
                   
                    payAmount: payAmount,
                   
                    selectedClient: agentCode,
                    
                    transaction: transactionId,
                     today: todayFormatted,

                    
                  }

                  const initiateres = await fetch('https://digitalapi.definiteassurance.com/api/approveInitiate', {
                    method: "POST",
                    headers: {
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    },
                    body: JSON.stringify(initiatePayload),
                    credentials: 'include'
                  })

                  const initiateData = await initiateres.json();
                  const { docNo2,noteOID2 } = initiateData;

            // Process createProposal for each entry in uploadedData
            try {
              const rows = [...uploadedData]
              let successfulApprovals = 0
              
              for (let i = 0; i < rows.length; i++) {
                const row = rows[i]
                
                // Update status to show processing
                setPaytext(`APPROVING ${i + 1} of ${rows.length}...`)
                
                try {
                  // Get today's date in the required format
                
                  // Calculate row-specific premium components based on GrossPremium
                  const grossPremium = parseFloat(row.GrossPremium) || 0
                  const rowStampduty = 40
                  const rowPremium = grossPremium > rowStampduty ? (grossPremium - rowStampduty) / 1.0045 : 0
                  const rowTrainingLevy = Math.round(0.002 * rowPremium)
                  const rowPHCF = Math.round(0.0025 * rowPremium)
                  const rowBasicPremium = Math.round(rowPremium + rowTrainingLevy + rowPHCF + rowStampduty)
                  const rowCommission = Math.round(0.1 * rowPremium)
                  const rowNetCommission = Math.round(0.1 * rowCommission)
                  const rowNetCommissionAdjusted = rowCommission - rowNetCommission
                  const rowNetPremium = rowBasicPremium - rowNetCommissionAdjusted

                  // Calculate coverDays from commencementUnix and expiryUnix
                  let rowCoverDays = 0
                  const commUnix = row.CommencementUnix || row.commencementUnix || ''
                  const expUnix = row.ExpiryUnix || row.expiryUnix || ''
                  if (commUnix && expUnix) {
                    try {
                      const commDate = new Date(commUnix)
                      const expDate = new Date(expUnix)
                      const diffTime = expDate.getTime() - commDate.getTime()
                      rowCoverDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1 // inclusive
                    } catch (e) {
                      console.error('Error calculating coverDays', e)
                    }
                  }
                  //Create notes


                  // Prepare the createProposal payload
                  const proposalPayload = {
                    utilize: 0,
                    proposalOID: row.proposalOID || proposalOID,
                    commissionRate: commissionRate || 0,
                    agentCode: agentCode || agent,
                    agentName: agentName || '',
                    prdCode: prdCode || '',
                    client: row.CustomerIDNumber || row.IDNumber || '',
                    commencementUnix: commUnix,
                    expiryUnix: expUnix,
                    today: todayFormatted,
                    coverDays: rowCoverDays,
                    reg: row.Registration || row.reg || '',
                    productCode: productCode || '',
                    payAmount: payAmount,
                    premium: Math.round(rowPremium),
                    basicPremium: rowBasicPremium,
                    commission: rowCommission,
                    stampduty: rowStampduty,
                    PHCF: rowPHCF,
                    trainingLevy: rowTrainingLevy,
                    netCommission: rowNetCommissionAdjusted,
                    netPremium: rowNetPremium,
                    selectedClient: row.clientOID || selectedClient,
                    makeCode: row.MakeCode || '',
                    modelCode: row.ModelCode || '',
                    capacity: row.Capacity || row.capacity || 0,
                    color: row.Color || row.color || '',
                    tonnage: row.Tonnage || row.tonnage || 0,
                    yom: row.YOM || row.yom || '',
                    coverOptioncode: coverOptioncode || '',
                    sumInsured: row.SumInsured || row.sumInsured || 0,
                    chassis: row.ChassisNumber || row.chassis || '',
                    engineNumber: row.EngineNumber || row.engineNumber || '',
                    cc: row.CC || row.cc || '',
                    selectedItem: selectedItem || '',
                    transaction: transactionId,
                    DSFApproved: DSFApproved || '',
                    parentIntermediary: parentIntermediary || '',
                  
                    docNo2: docNo2 || '',
                  
                    noteOID2: noteOID2 || '', 
                  }

                  const approvalRes = await fetch('https://digitalapi.definiteassurance.com/api/createProposal3', {
                    method: "POST",
                    headers: {
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    },
                    body: JSON.stringify(proposalPayload),
                    credentials: 'include'
                  })

                  const approvalData = await approvalRes.json()
                  
                  if (approvalData.success) {
                    successfulApprovals++
                    console.log(`Approval successful for row ${i + 1}`, row)

                    // Generate certificate for this policy
                    try {
                      setPaytext(`GENERATING CERTIFICATE ${i + 1} of ${rows.length}...`)
                      
                      // Format phone number
                      const rowPhone = row.CustomerPhoneNumber || row.CustomerPhone || row.Phone || ''
                      const formattedNumber = rowPhone.startsWith('0') ? rowPhone.slice(1) : rowPhone
                      
                      // Format commencement date (convert from Unix to readable format)
                      const commDate = new Date(commUnix)
                      const commencementDate = `${String(commDate.getDate()).padStart(2, '0')}/${String(commDate.getMonth() + 1).padStart(2, '0')}/${commDate.getFullYear()}`
                      
                      // Format expiry date
                      const expDate = new Date(expUnix)
                      const expiryDate = `${String(expDate.getDate()).padStart(2, '0')}/${String(expDate.getMonth() + 1).padStart(2, '0')}/${expDate.getFullYear()}`
                      
                      const certificatePayload = {
                        IOID: row.IOID || insuredSchedule,
                        insuredOID: row.insuredOID || insuredOID,
                        dateDone: dateDone,
                        selectedItem: selectedItem || '',
                        proposalOID: row.proposalOID || proposalOID,
                        coverType: coverType || '',
                        clientName: `${row.CustomerFirstName || row.CustomerName || ''} ${row.CustomerLastName || ''}`.trim(),
                        policyNumber: row.policyNumber || policyNumber,
                        commencementUnix: commUnix,
                        commencementDate: commencementDate,
                        expiryUnix: expUnix,
                        expiryDate: expiryDate,
                        reg: row.Registration || row.reg || '',
                        chassis: row.ChassisNumber || row.chassis || '',
                        clientPhone: formattedNumber,
                        bodyType: bodyType || '',
                        capacity: row.Capacity || row.capacity || 0,
                        makeName: row.Make || row.make || makeName || '',
                        modelName: row.Model || row.model || modelName || '',
                        engineNumber: row.EngineNumber || row.engineNumber || '',
                        clientEmail: row.CustomerEmail || row.Email || '',
                        sumInsured: row.SumInsured || row.sumInsured || 0,
                        clientPin: row.CustomerKRA || row.KRA || row.Pin || '',
                        yom: row.YOM || row.yom || '',
                        iraCode: iraCode || '',
                        tonnage: row.Tonnage || row.tonnage || 0,
                        iraNumber: iraNumber || '',
                        DSFApproved: DSFApproved || '',
                        parentIntermediary: parentIntermediary || '',

                      }

                      const certRes = await Axios.post(
                        'https://sms.definiteassurance.com/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0',
                        certificatePayload
                      )

                      if (certRes.data.success) {
                        await insertCertificate(
                          certRes.data.certURL,
                          certRes.data.certNo,
                          commUnix,
                          expUnix,
                          row.proposalOID || proposalOID,
                          row.insuredOID || insuredOID
                        )
                        setCertURL(certRes.data.certURL)
                        console.log(`Certificate generated successfully for row ${i + 1}`)
                      } else {
                        await insertCertificateError(
                          certRes.data.errorMessage,
                          row.proposalOID || proposalOID,
                          row.insuredOID || insuredOID,
                          expUnix,
                          commUnix
                        )
                        console.error(`Certificate generation failed for row ${i + 1}`, certRes.data.errorMessage)
                      }
                    } catch (certErr) {
                      console.error(`Certificate generation error for row ${i + 1}`, certErr)
                      // Continue even if certificate generation fails
                    }
                  } else {
                    console.error(`Approval failed for row ${i + 1}`, row, approvalData)
                  }
                } catch (approvalErr) {
                  console.error(`Approval error for row ${i + 1}`, row, approvalErr)
                }
              }

              // All approvals processed
              setPaytext('APPROVAL COMPLETE')
              toast.success(`${successfulApprovals} of ${rows.length} policies approved successfully!`)
              
              // Redirect to active policies page after a short delay
              setTimeout(() => {
                setModal2(false)
                setIscert(0)
                navigate('/active-policies')
              }, 2000)
              
            } catch (approvalProcessErr) {
              console.error('Error processing approvals:', approvalProcessErr)
              toast.error('Approval process failed')
              setPaytext('APPROVAL FAILED')
              setMpesaclicked(false)
            }
          } else {
            // Payment failed
            toast.error('Payment failed. Please try again.')
            setPaytext('SEND REQUEST')
            setMpesaclicked(false)
            console.error('Payment failed:', responseData)
          }
        } catch (error) {
          // Error in payment request
          toast.error('Payment request failed. Please try again.')
          setPaytext('SEND REQUEST')
          setMpesaclicked(false)
          console.error('Payment error:', error)
        }
  }

  // Approve all proposals in bulk with a single receipt
const approveAllProposals = async (proposalsArray) => {
  try {
    setPaytext('APPROVING POLICIES...')
    const res = await fetch('https://digitalapi.definiteassurance.com/api/createProposal3', {
      method: 'POST',
      headers: {
        'Authorization': `Basic ${credentials}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ proposals: proposalsArray }),
      credentials: 'include'
    });
    const data = await res.json();
    if (data.success) {
      toast.success('All proposals approved and allocated with a single receipt!');
      // Optionally, handle receiptOID: data.receiptOID
      // Continue with certificate generation or redirect as needed
    } else {
      toast.error('Approval failed: ' + (data.message || data.error));
    }
  } catch (err) {
    toast.error('Approval error: ' + err.message);
  }
};

  useEffect(()=>{
  const getCredentials =async()=>{
  const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
  const data = await res.json();
  const {Username, Password} = data;
  const cred = btoa(`${Username}:${Password}`)
  setCredentials(btoa(`${Username}:${Password}`))
  setIsauth(true)


  }
  getCredentials()

  },[])

  useEffect(() => {
        
      const user = localStorage.getItem('definiteagent'); // Retrieve email
      if (user) {
          
          setAgent(user)
      } else {
  
      }
      }, []);

  useEffect(()=>{
      const getAgentcode =async()=>{
          const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                method:"GET",
          headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
          }
          });
          const data = await res.json();
          setAgentcode(data.OID)   

      }
      if(agent && isAuth){
          getAgentcode()
      }
  },[agent,isAuth])


  useEffect(()=>{
      const getProducts =async()=>{
          const res = await fetch('https://digitalapi.definiteassurance.com/api/getProducts',{
                method:"GET",
              headers:{
                'Authorization': `Basic ${credentials}`,
                'Content-Type': "application/json"
              }
          });
          const data = await res.json();
          setProducts(data)
      }

    
      if(isAuth){
          getProducts();
          
      }

    

  },[isAuth])

     useEffect(()=>{
      const getProductdetails =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getThisproduct?OID=${productCode}`,{
            method:"GET",
            headers:{
                'Authorization': `Basic ${credentials}`,
                'Content-Type': "application/json"
            }
        });
        const data = await res.json();
        setProductname(data.ProductDescription)
        // const prd = data.ProductCode
        setPrdcode(data.ProductCode.replace(/PRD-/g, ''))
        setCommissionrate(data.CommissionRate)
        setIracode(data.IRACode)
        setRiskclass(data.RiskClass)

    }
     
  
      const getCoveroptions =async()=>{
          const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCoveroptions?product=${productCode}`,{
               method:"GET",
                  headers:{
                    'Authorization': `Basic ${credentials}`,
                    'Content-Type': "application/json"
                  }
          })
          const data = await res.json();
          setCoveroptions(data)
      }
  
      if(productCode && isAuth){
          getProductdetails()
          getCoveroptions();
      }
  
     },[productCode,isAuth])
     
   useEffect(()=>{
    const getInsureditems =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getInsureditems?coverOption=${coverOptioncode}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setInsureditems(data)
        if(data.length == 1){
              setSelecteditem(data[0].OID)
        }
      

    }

    const getCoveroptiondetails =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCoveroptiondetails?cover=${coverOptioncode}`,{
             method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setCoveroption(data.CoverOption)
    }
    if(coverOptioncode && isAuth){
        getInsureditems();
        getCoveroptiondetails();
    }

   },[coverOptioncode,isAuth])
  return (
    <div>
          <div className="page-content">
                <ToastContainer />
                <Breadcrumbs title="Definite Assurance" breadcrumbItem='Bulk Processing' />
                <Card className="mini-stats-wid">
                    <CardBody>
                        <h6>Basic information</h6>
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
                         
                          <div>
                            <small>{uploadedData.length} row(s) loaded</small>
                          </div>
                        </div>

                        <div className="bulkContainer">
                          <div className="bulkLeft">
                           <div className="entryField">
                             <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SELECT PRODUCT" onChange={(e)=>{setProductcode(e.target.value)}}>
                                <Form.Select className='inputSearch'>
                                    <option selected disabled>SELECT PRODUCT</option>
                                  
                                        <>
                                        {products.map((val)=>{
                                        return(
                                            <option key={val.OID} value={val.OID}>{val.ProductDescription}</option>
                                        )
                                        })}
                                        </>      
                                </Form.Select>
                            </FloatingLabel>
                              <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="SELECT COVER OPTION" onChange={(e)=>{setCoveroptioncode(e.target.value)}}>
                              <Form.Select className='inputSearch'>
                                  <option selected disabled>SELECT COVER OPTION</option>
                                  
                                  {coverOptions.map((val)=>{
                                          return(
                                                <option key={val.OID} value={val.OID}>{val.OptionName}</option>
                                          )
                                          
                                    
                                      
                                  })}
                                  
                              </Form.Select>
                            </FloatingLabel>

                            <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="PAYMENT INTERVAL" onChange={(e)=>{setCoverperiod(e.target.value)}}>
                                <Form.Select className='inputSearch'>
                                    <option selected disabled>Number of Installments</option>
                                    {((productCode==4638 && coverOption == 2)  || (productCode == 3587 && coverOption == 2)) &&
                                        <>
                                            <option value="Week">7 Days</option>
                                            <option value="Fortnight">14 Days</option>
                                            <option value="Monthly">30 Days</option>
                                            <option value="Annually">Annual</option>
                                            <option value="3Installments">3 Installments</option>
                                            <option value="6Installments">6 Installments</option>
                                            <option value="10Installments">10 Installments</option>
                                        </>
                                    
                                    }
                                    
                                    {((productCode != 4638 && coverOption == 2) && (productCode != 3587 && coverOption == 2)) &&
                                      
                                        <>
                                          {(productCode != 4695 && productCode != 4694) &&
                                            <>
                                                <option value="Annually">Annual</option>
                                                <option value="2installments">2 Installments</option>
                                            </>
                                          
                                          }
                                            
                                        </>

                                    }
                                      {((productCode!==4638 && coverOption==1) && (productCode !==3587 && coverOption == 1)) &&

                                      <>
                                        <option value="Monthly">30 Days</option>
                                        <option value="3installments">3 Installments</option>
                                      </>

                                    }
                                    {((productCode!==4638 && coverOption==58) && (productCode !==3587 && coverOption == 58)) &&
                                                                            <>
                                          <option value="Monthly">30 Days</option>
                                        <option value="3installments">3 Installments</option>
                                      </>
                                    }

                                    {(productCode == 4695 || productCode == 4694) &&
                                          <option value="Monthly">30 Days</option>
                                    }
                                    
                                </Form.Select>
                            </FloatingLabel>
                           
                           </div>
                          </div>
                          <div className="bulkRight">
                           <h6>Bulk Upload</h6>
                           <div >
                            
                            <div className="">
                                  <Button color="primary" onClick={downloadSampleCsv}>Download sample CSV</Button>
                            </div>
                                <br />     
                             <div style={{display:'flex',flexDirection:'column'}}>
                               <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
                               <div style={{marginTop:8}}>
                                 <Button color="success" onClick={uploadFile} disabled={!selectedFile || uploading}>
                                   {uploading ? 'Uploading...' : 'Upload CSV'}
                                 </Button>
                               </div>
                             </div>
                           </div>
                           {selectedFile && <div style={{marginTop:8}}><small>Selected file: {selectedFile.name}</small></div>}
                          </div>
                        </div>
                        <hr />
                        <div className="uploadedContainer">
                         <h4>Processed Data</h4>
                         
                        </div>

                        {/* Uploaded CSV preview */}
                        <div className="uploadedContainer" style={{marginTop:20}}>
                          {uploadedData && uploadedData.length > 0 ? (
                            <>
                              <Table striped bordered hover responsive size="sm">
                                <thead>
                                  <tr>
                                    {['CustomerFirstName','CustomerLastName','CustomerIDNumber','CustomerPhoneNumber','CustomerKRA','CommencementDate','CommencementUnix','ExpiryUnix','Registration','Capacity','Make','MakeCode','Model','ModelCode','ChassisNumber','EngineNumber','YOM','CC','Color','GrossPremium'].map(h => (
                                      <th key={h}>{h}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {uploadedData.map((row, idx) => (
                                    <tr key={idx}>
                                      {['CustomerFirstName','CustomerLastName','CustomerIDNumber','CustomerPhoneNumber','CustomerKRA','CommencementDate','CommencementUnix','ExpiryUnix','Registration','Capacity','Make','MakeCode','Model','ModelCode','ChassisNumber','EngineNumber','YOM','CC','Color'].map(col => (
                                        <td key={col}>{row[col]}</td>
                                      ))}
                                      <td>{row.GrossPremium ?? ''}</td>
                                     
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <div style={{marginTop:12}}>
                                {!processed ? (
                                  <Button color="primary" onClick={processPolicies} disabled={uploading || !uploadedData.length}>
                                    Process Policies
                                  </Button>
                                ) : (
                                  <>
                                    <Button color="danger" onClick={clearUploadedData}>Clear Data</Button>
                                    {!paymentInitiated ? (
                                      <Button color="success" onClick={buyCover} style={{marginLeft:8}} disabled={uploading}>
                                        {uploading ? 'Processing...' : 'Buy Cover'}
                                      </Button>
                                    ) : (
                                      <Button color="primary" onClick={() => setModal2(true)} style={{marginLeft:8}}>Make Payment</Button>
                                    )}
                                  </>
                                )}
                              </div>
                            </>
                          ) : (
                            <div>No uploaded data</div>
                          )}
                        </div>
                         <div style={{
                            backgroundColor: 'red',
                            color: 'white',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            width:'30%',
                            marginTop:'3%'
                          }}>
                            <span>Total Payable Premium: KES {Number(totalGross).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</span>
                          </div>
                    </CardBody>
                </Card>
          </div>


                  <Modal isOpen={modal2}>
                      <ModalHeader>MAKE PAYMENT</ModalHeader>
                      <div className="modalContainer">
          
                          {isCert == 0 &&
                          
                          <>
                          
          
                         
                          <hr />
                          <h6>Amount to pay: Kes. {formatter(payAmount)}</h6>
                          <hr />
                          <div className="checkboxes">
                         
          
                          </div>
                         
          
                              {isMpesa &&
                                  <FloatingLabel 
                                  className='formInput2' 
                                  controlId="floatingInputGrid" 
                                  label="MPESA NUMBER*"
                                  onChange={(e) => setMpesaphone(e.target.value)}
                              >
                                  <Form.Control 
                                      className='inputSearch' 
                                      value={mpesaPhone} 
                                      type="text" 
                                      placeholder="MPESA NUMBER" 
                                  />
                              </FloatingLabel>
                              
                              }
                 
                          {promptID == 0 &&
                               <Button color="success" className="quoteButton2" onClick={initiatePayment} >{payTest}</Button>

                          }
                          {promptID == 1 &&
                               <Button color="success" className="quoteButton2"  >{resendText}</Button>
                          
                          }

                          
                          </>
                          
                          
                          }
                          {isCert == 1 &&
                          <>
                              <a style={{backgroundColor:'green',width:'100%',color:'white',padding:'10px',borderRadius:'5px',marginBottom:'20px'}} href={certURL} target="_blank" rel="noreferrer">DONWLOAD CERTIFICATE</a>
                              <p style={{marginTop:'15px'}}>DISCLAIMER: If Certificate does not download, click the 'DOWNLOAD BUTTON' again!</p>
                             
                              <hr />
                          </>
                          
                          
                          }
                          {isCert == 2 &&
                          <>
                              <p style={{color:'red'}}>ERROR: {errorMessage}</p>
                              <Button color="success" onClick={retryCertficate}>{retryText}</Button>
                          </>
                          
                          }
                     
                          {/* <div className="">
                              <p style={{color:'green',marginTop:'5%',float:'left',cursor:'pointer'}} onClick={finish}>FINISH</p>
                          </div> */}
                          
                          {isCert == 0 &&
                          
                              <p style={{color:'red',marginTop:'5%',float:'right',cursor:'pointer'}} onClick={close2}>BACK</p>
                          }
                        
                      </div>
                  </Modal>
    </div>
  )
}